const getToday = () => {
    let now = new Date();
    let today = now.toISOString().substring(0,10);
    return today;
}

const checkModalLastClosed = () => {
    let today = getToday();
    let lastClosed = localStorage.getItem('exitintent_show');
    return today == lastClosed;
}

const mouseLeaveEvent = () => {
    const modal = document.querySelector('#b4ugoModal');
        
    if (!modal.isOpen) {
        modal.open();
        modal.addEventListener('closeButton', () => {
            let today = getToday();
            localStorage.setItem('exitintent_show', today)
            let body = document.getElementById('body');
            body.removeEventListener('mouseleave', mouseLeaveEvent, {passive:true});
        })
    }
}

if (document.getElementById('b4ugoModal')) {
    
    if (!checkModalLastClosed()) {
        const body = document.querySelector('body');
        body.addEventListener('mouseleave', mouseLeaveEvent);
    }
}
